<kilowant-header title="Add Client"></kilowant-header>
<div class="backgroundImage">
  <div class="wrapperMain mainAccountDetailsMain accountDetails">
    <div class="form buyer">
      <section>
          <div class="card">
              <input type="text" name="clientName" placeholder="Client Name" (input)="resetError('ClientName')" [(ngModel)]="clientInfo.alias" [class]="getClassesForInput('ClientName', true, clientInfo.alias)" />
              @if (getVisibilityForLabel(clientInfo.alias)) {
              <div class="placeholder">Client Name</div>
              }
              <select class="placeholder" [(ngModel)]="clientType" (change)="switchClientType()">
                  <option [selected]="(clientType=='Residential')">Residential</option>
                  <option [selected]="(clientType=='Commercial')">Commercial</option>
              </select>
              <div class="placeholder">Client Class</div>

              @if (clientType=='Commercial') {
              <input name="company" [(ngModel)]="this.clientInfo!.company!.name" (input)="resetError('FederalTaxID')" [class]="getClassesForInput('CompanyName', true, this.clientInfo!.company!.name)" placeholder="Company" />
              @if (getVisibilityForLabel(this.clientInfo!.company!.name)) {
              <div class="placeholder">Company</div>
              }
              }
              <input type="text"
                     name="addressLine1"
                     [class]="getClassesForInput('addressLine1', true, clientInfo.addressLine1)"
                     (input)="resetError('addressLine1')"
                     placeholder="Address Line 1"
                     [(ngModel)]="clientInfo.addressLine1"
                     [minlength]="validationService.getMinLength('User', 'address')"
                     [maxlength]="validationService.getMaxLength('User', 'address')" />
              @if (getVisibilityForLabel(clientInfo.addressLine1)) {
              <div class="placeholder">Address Line 1</div>
              }
              <input type="text"
                     name="addressLine2"
                     [class]="getClassesForInput('addressLine2', true, clientInfo.addressLine2)"
                     (input)="resetError('addressLine2')"
                     placeholder="Address Line 2"
                     [(ngModel)]="clientInfo.addressLine2"
                     [minlength]="0"
                     [maxlength]="validationService.getMaxLength('User', 'address')" />
              @if (getVisibilityForLabel(clientInfo.addressLine2)) {
              <div class="placeholder">Address Line 2</div>
              }

              <div class="cols">
                  @if (cityStateShow() || (clientInfo.city!=null && clientInfo.city.length>0)) {
                  <div class="col auto">
                      <input type="text" name="City" [value]="clientInfo.city" [disabled]="true" class="placeholder" />
                      <div class="placeholder">City</div>
                  </div>
                  }
                  @if (cityStateShow() || (clientInfo.state!=null)) {
                  <div class="col">
                      <input type="text" name="State" style="width: 60px;" [value]="getStateName(clientInfo.state)" [disabled]="true" class="placeholder" />
                      <div class="placeholder">State</div>
                  </div>
                  }
                  <div class="col" [class]="(cityStateShow() || clientInfo.state!=null)?'':'auto'">
                      <input type="text"
                             name="address"
                             [class]="getClassesForInput('zip', true, clientInfo.zip)"
                             [style]="(cityStateShow() || clientInfo.state!=null)?'width: 70px;':''"
                             (input)="zipChanged()"
                             placeholder="Zip"
                             [(ngModel)]="clientInfo.zip"
                             [minlength]="validationService.getMinLength('User', 'zip')"
                             [maxlength]="validationService.getMaxLength('User', 'zip')" />
                      @if (getVisibilityForLabel(clientInfo.zip)) {
                      <div class="placeholder">Zip</div>
                      }
                  </div>
              </div>
              <div style="background-color: #EEE; padding: 10px; border-radius: 4px;" class="mb-10">
                  <div class="mt-10">
                      <select name="kilowantAccess" class="placeholder" [(ngModel)]="kilowantAccess" (change)="changeClientContact()">
                          <option value="1">Client contact</option>
                          <option value="2">Client manager contact</option>
                      </select>
                  </div>
                  <div class="placeholder">Contact Class</div>

                  @if (kilowantAccess==2) {
                  <select class="placeholder" [compareWith]="compareKeyFn" [(ngModel)]="externalContact" (change)="changeExternalContact()">
                      <optgroup label="Existing Manager Contacts">
                          @for (contactManager of contactManagers; track contactManager) {
                          <option [ngValue]="contactManager">{{contactManager.value}}</option>
                          }
                      </optgroup>
                      <optgroup label="Add a new Manager Contacts">
                          <option [ngValue]="null">Add</option>
                      </optgroup>
                  </select>
                  <div class="placeholder">Manager Contact</div>
                  }

                  @if ((kilowantAccess==1 || kilowantAccess==2) && editContact!=null) {
                  <div class="table-view">
                      <div class="row">
                          <div class="cell">
                              <input type="text" name="FirstName" [disabled]="clientEditDisabled()" [class]="getClassesForInput('FirstName', true, editContact.firstName)" (input)="resetError('FirstName')" placeholder="First name" [(ngModel)]="editContact.firstName" [minlength]="validationService.getMinLength('User', 'firstName')" [maxlength]="validationService.getMaxLength('User', 'firstName')" />
                              @if (getVisibilityForLabel(editContact.firstName)) {
                              <div class="placeholder">First name</div>
                              }
                          </div>
                          <div class="cell">
                              <input type="text" name="LastName" [disabled]="clientEditDisabled()" [class]="getClassesForInput('LastName', true, editContact.lastName)" (input)="resetError('LastName')" placeholder="Last name" [(ngModel)]="editContact.lastName" [minlength]="validationService.getMinLength('User', 'lastName')" [maxlength]="validationService.getMaxLength('User', 'lastName')" />
                              @if (getVisibilityForLabel(editContact.lastName)) {
                              <div class="placeholder">Last name</div>
                              }
                          </div>
                      </div>
                  </div>
                  <input type="text" name="Email" class="w-100" [disabled]="clientEditDisabled()" [class]="getClassesForInput('Email', true, editContact.email)" (input)="resetError('Email')" [(ngModel)]="editContact.email" placeholder="Email" />
                  @if (getVisibilityForLabel(editContact.email)) {
                  <div class="placeholder">Email</div>
                  }
                  <input type="text" name="Phone"
                         [disabled]="clientEditDisabled()"
                         [class]="getClassesForInput('Phone', true, (((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'1':'')))"
                         (input)="resetError('Phone')"
                         placeholder="Mobile Phone"
                         [dropSpecialCharacters]="false"
                         [formControl]="currentPhoneNumber"
                         (focus)="focusField('Phone')"
                         mask="(000) 000-0000"
                         [showMaskTyped]="(focusedField()=='Phone')||(currentPhoneNumber.value!=null && currentPhoneNumber.value?.trim()!='' && !currentPhoneNumber.value.valid)" />
                  @if (getVisibilityForLabel(((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'phone':''))) {
                  <div class="placeholder">Mobile Phone</div>
                  }
                  }
                  <div style="text-align: right; margin-top: -10px; font-size: 13px;">
                      @if (clientEditDisabled()) {
                      <a (click)="addUpdateContactManager()" class="link">Update</a>
                      }
                  </div>
              </div>

              @if (clientType=='Commercial' && clientInfo!.company!=null) {
              <div>
                  <div class="mb-10 mt-10">
                      <label>
                          <input type="checkbox" name="taxExempt" [(ngModel)]="taxExempt" /> Client is Tax Exempt
                      </label>
                  </div>
                  @if (taxExempt) {
                  <div>
                      <input type="text" name="FederalTaxID" class="w-100"
                             [class]="getClassesForInput('FederalTaxID', true, federalTaxID)" value=""
                             (input)="resetError('FederalTaxID')" [(ngModel)]="federalTaxID"
                             placeholder="Federal Tax ID" />
                      @if (getVisibilityForLabel(federalTaxID)) {
                      <div class="placeholder">Federal Tax ID</div>
                      }
                      <div class="mt-20"> Please upload a photo or a copy of your tax exempt certificate.</div>
                      @if ((fileToUpload==null) && taxExemptCertificateDocument==null) {
                      <label class="formLabel"
                             [class]="(errorY().isWrong('fileToUpload'))?'error':''">
                          CHOOSE FILES
                          <span>no files selected</span>
                          <input type="file" name="taxExemptCertificateDocument" class="required" value=""
                                 placeholder="Tax Exempt Certificate Document" (change)="handleFileInput($event)" />
                      </label>
                      }
                      @if (fileToUpload!=null || taxExemptCertificateDocument!=null) {
                      <div class="files-list">
                          <span>File selected</span>
                          <ul>
                              @if (taxExemptCertificateDocument!=null) {
                              <li>
                                  <a (click)="deleteExistingFile(taxExemptCertificateDocument.key)"></a>
                                  <div class="link" (click)="downloadFile(true, taxExemptCertificateDocument.key)">{{taxExemptCertificateDocument.value}}</div>
                              </li>
                              }
                              @if (fileToUpload!=null) {
                              <li>
                                  <a (click)="deleteFile()"></a>
                                  <div class="link" (click)="downloadFile(false, null)">{{fileToUpload.name}}</div>
                              </li>
                              }
                          </ul>
                      </div>
                      }
                  </div>
                  }
              </div>
              }

              @if (errorY().showError()) {
              <div class="error-block">{{errorY().error}}</div>
              }
          </div>
              </section>

              <div class="block-buttons full-width mb-20 under-card">
                <button type="button" (click)="goBack()">Back</button>
                <button appOneClick type="button" class="highlighted-button" (oneClick)="confirm()">Confirm</button>
              </div>
            </div>
          </div>
        </div>